import { Injectable, OnDestroy } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { io, Socket } from "socket.io-client";
import { environment } from "../../../environments/environment";
import { WsData } from "../../models";
import { ReferenceSummary } from "../../models/reference-summary";

export interface WebSocketInstance {
  socket: Socket;
  message: Subject<string>;
  authValidate: boolean;
}

@Injectable()
export class WebSocketService implements OnDestroy {
  private readonly TIMEOUT: number = 10 * 60 * 1000;

  sockets: Map<string, WebSocketInstance> = new Map();

  private timeout: ReturnType<typeof setTimeout>;
  private timeoutAuth: ReturnType<typeof setTimeout>;

  messages: Subject<any>;

  public ngOnDestroy(): void {
    clearTimeout(this.timeout);
    clearTimeout(this.timeoutAuth);
  }

  public async connect(namespace: string) {
    try {
      const socket: Socket = await io(`${environment.apiUrl}${namespace}`, {
        query: { token: this.getToken() },
        path: "/socket.io",
        transports: ["websocket"],
        secure: true
      });
      socket.on("error", (message) => {
        //TODO handle logout
        console.log("error websocket : ", message);
      });
      const message: Subject<string> = new Subject();
      const authValidate = false;
      const webSocketInstance: WebSocketInstance = {
        socket: socket,
        message: message,
        authValidate: authValidate
      };
      this.sockets.set(namespace, webSocketInstance);
      console.log(this.sockets);
    } catch (e) {
      console.log(e);
    }
  }

  public async sendMessage(message: WsData, namespace: string) {
    const webSocketInstance: WebSocketInstance = this.sockets.get(namespace);
    if (webSocketInstance.authValidate) {
      console.log("sendmessage websocket instance: ", webSocketInstance);
      message.userName = this.getName();
      await webSocketInstance.socket.emit("message", JSON.stringify(message));
    } else {
      this.timeoutAuth = setTimeout(() => {
        this.sendMessage(message, namespace);
      }, 100);
    }
  }

  public getNewMessage(namespace: string): Observable<string> {
    const webSocketInstance: WebSocketInstance = this.sockets.get(namespace);
    console.log("getnewmessage :", webSocketInstance);
    webSocketInstance.socket.on("message", (message) => {
      console.log("message instance :", message);
      if (webSocketInstance.authValidate) {
        webSocketInstance.message.next(message);
        clearTimeout(this.timeout);
        this.timeout = setTimeout(
          () => this.handleTimeout(webSocketInstance.message),
          this.TIMEOUT
        );
      }
      if (!webSocketInstance.authValidate && message === this.getName()) {
        webSocketInstance.authValidate = true;
      }
    });
    return webSocketInstance.message.asObservable();
  }

  public async disconnect(namespace: string) {
    const webSocketInstance: WebSocketInstance = this.sockets.get(namespace);
    if (webSocketInstance) {
      webSocketInstance.authValidate = false;
      await webSocketInstance.socket.disconnect();
      clearTimeout(this.timeout);
      this.sockets.delete(namespace);
    }
  }

  private getToken(): string {
    return localStorage.getItem("password");
  }

  private getName(): string {
    return localStorage.getItem("username");
  }

  handleTimeout(message: Subject<string>) {
    const referenceSummary: ReferenceSummary = {
      info: [],
      warnings: ["Timeout error"]
    };
    const wsData: WsData = {
      messageType: "Error",
      userName: this.getName(),
      referenceType: "Timeout",
      referenceSummary: referenceSummary
    };
    message.next(JSON.stringify(wsData));
  }
}
